import { render, staticRenderFns } from "./org-case-strategy-allot.vue?vue&type=template&id=4c9d2d1e&scoped=true"
import script from "./org-case-strategy-allot.vue?vue&type=script&lang=ts"
export * from "./org-case-strategy-allot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d2d1e",
  null
  
)

export default component.exports